__turbopack_context__.v({
  "DoubleGrid": "GridTeaser-module-scss-module__HyEuva__DoubleGrid",
  "GridTeaser": "GridTeaser-module-scss-module__HyEuva__GridTeaser",
  "GridWithBackground": "GridTeaser-module-scss-module__HyEuva__GridWithBackground",
  "HasHoverEffect": "GridTeaser-module-scss-module__HyEuva__HasHoverEffect",
  "QuadtripleGrid": "GridTeaser-module-scss-module__HyEuva__QuadtripleGrid",
  "TripleGrid": "GridTeaser-module-scss-module__HyEuva__TripleGrid",
});
